import React from "react";
import { Layout as AntLayout, theme } from "antd";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import Header from "./Header";
import Footer from "./Footer";
import GitlabTicketFloatButton from "../GitlabTicketFloatButton";

const { Content } = AntLayout;

const contentStyle = { padding: "20px 48px" };
const layoutStyle = { overflow: "hidden" };

function useSelectedKeys() {
  const location = useLocation();
  const path = location.pathname;

  if (path === "/") return ["home"];
  if (path.startsWith("/data-services")) return ["services"];
  if (path.startsWith("/data-catalog")) return ["data", "/data-catalog"];
  if (path.startsWith("/donate-dataset")) return ["data", "/donate-dataset"];
  if (path.startsWith("/discover-data")) return ["data", "/discover-data"];
  if (path.startsWith("/data-stewardship"))
    return ["data", "/data-stewardship"];
  if (path.startsWith("/hpc-flows")) return ["data", "/hpc-flows"];
  if (path.startsWith("/staging-ticket"))
    return ["infrastructure", "/staging-ticket"];
  if (path.startsWith("/software-catalog")) return ["software", "software-catalog"];
  if (path.startsWith("/model-catalog")) return ["models", "model-catalog"];
  if (path.startsWith("/admin/hpc-flows"))
    return ["admin", "admin-hpc-flows"];
  if (path.startsWith("/admin/hpc-keys")) return ["admin", "admin-hpc-keys"];
  if (path.startsWith("/admin")) return ["admin", "admin-dashboard"];

  return [];
}

function Layout({ children }) {
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();
  const selectedKeys = useSelectedKeys();
  const { user } = useAuth();

  return (
    <AntLayout style={{ ...layoutStyle, background: colorBgContainer }}>
      <Header selectedKeys={selectedKeys} />
      {/* ProjectOffice integration (removed). */}

      <Content style={contentStyle}>
        <div
          style={{
            background: colorBgContainer,
            borderRadius: borderRadiusLG,
            padding: 24,
            minHeight: "calc(100vh - 170px)",
          }}
        >
          {children}
        </div>
      </Content>

      <Footer />
      {user && <GitlabTicketFloatButton />}
    </AntLayout>
  );
}

export default Layout;
